import { render, staticRenderFns } from "./SafetyEditor.vue?vue&type=template&id=95cfd764&scoped=true"
import script from "./SafetyEditor.vue?vue&type=script&lang=js"
export * from "./SafetyEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95cfd764",
  null
  
)

export default component.exports